module.exports = __webpack_public_path__ + "img/swiper-pro.14565594.png";